import { IControlProperties } from '../entities';
import { IDataGridColumn } from '../environments/runtime/components/DataGrid2/entities';

export const calculateFormat = (bcColumn: IDataGridColumn<IControlProperties>) => {
	let format = '';

	if (bcColumn.useThousandSeparator) {
		format = format.concat(',##0');
	} else {
		format = format.concat('##0');
	}

	if (bcColumn.precision) {
		let precisionParser = '';

		for (let index = 0; index < bcColumn.precision; index++) {
			precisionParser = precisionParser.concat('0');
		}

		format = format.concat(`.${precisionParser}`);
	}

	return format;
};
